import { ALL_ACTIONS } from '../../constants';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const withObstructionPermission = (WrappedComponent: React.ComponentType<any>) => {
	const ComponentWithPermission = (props: any) => {
		const allowedActions = useSelector((state: RootState) => state.roleState.data.allowedActions);
		if (!(allowedActions.includes(ALL_ACTIONS.ADD_OBSTRUCTIONS)) && !(allowedActions.includes(ALL_ACTIONS.DELETE_OBSTRUCTIONS))) {
			return null;
		}

		return <WrappedComponent {...props} />;
	};

	ComponentWithPermission.displayName = `WithPermission(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

	return ComponentWithPermission;
};

export default withObstructionPermission;